import JobWorkerRejectedReason from "@/models/JobWorkers/JobWorkerRejectedReason";
import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateJobWorkerStatusOfferRequest extends BaseUpdateRequest  { 
    jobWorkerId = '';
}
